module.exports = __webpack_public_path__ + "img/earth.86c99527.svg";